import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthenticationComponent} from "./authentication.component";
import { ButtonModule } from "src/app/ui-components/buttons/button.module";
// import { ModalModule } from 'ngx-bootstrap/modal';
// import {AddCardModalComponent} from "../addCard-modal/addCard-modal.component";
// import { ClickOutsideModule } from 'ng-click-outside';

@NgModule({
    declarations: [AuthenticationComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule
    ],
    exports: [AuthenticationComponent]
})
export class AuthenticationModule {
}
